<template>
  <div
    class="actionDetails"
    @click.self="closeModal"
  >
    <div
      ref="content"
      class="actionDetails-content"
      @click="closeDropdowns"
    >
      <h2 class="action-title">
        {{ card.title }}
      </h2>

      <div class="field-section">
        <div class="field-header">
          <svg
            class="field-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M3 6h18v2H3V6zm0 5h13v2H3v-2zm0 5h18v2H3v-2z" />
          </svg>
          <span class="field-title">Descrição</span>
        </div>

        <textarea
          ref="descriptionTextarea"
          v-model="editedDescription"
          class="description-textarea"
          :maxlength="descriptionMaxLength"
          placeholder="Detalhes da ação..."
          rows="1"
        />
        <div class="description-counter">
          {{ editedDescription.length }} / {{ descriptionMaxLength }}
        </div>
      </div>

      <div class="field-section">
        <div class="field-header">
          <svg
            class="field-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" />
          </svg>
          <span class="field-title">Prazo</span>
        </div>

        <p
          v-if="selectedDueDate"
          class="selected-due-date"
        >
          {{ $Utilities.formatDate(selectedDueDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
        </p>
        <div>
          <vue-cal
            class="vuecal--date-picker small-calendar vuecal--purple-theme"
            xsmall
            style="margin-bottom: 30px;"
            hide-view-selector
            :time="false"
            :transitions="false"
            active-view="month"
            locale="pt-br"
            :disable-views="['week']"
            :selected-date="selectedDueDate"
            @cell-click="selectDate"
          />
        </div>
      </div>

      <div class="field-section">
        <div class="field-header">
          <svg
            class="field-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
          <span class="field-title">Profissional</span>
        </div>

        <div class="professional-select">
          <div
            class="professional-assigned-box"
            @click.stop="toggleProfessionalsDropdown"
          >
            <img
              :src="
                selectedProfessional?.Photo ||
                  require('@/assets/images/default_avatar_neutral.png')
              "
              class="default-avatar circular-mask small-image-35"
            >
            <p>{{ selectedProfessional?.Name || 'Atribuir' }}</p>
            <svg
              class="chevron-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </div>
          <ul
            v-if="professionalsDropdownVisible"
            class="professionals-assigned-dropdown-list"
            @click.stop
          >
            <li
              v-for="professional in professionals"
              :key="professional.Id"
              class="dropdown-item"
              @click="selectProfessional(professional)"
            >
              {{ professional.Name }}
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-buttons">
        <button
          class="btn-cancel"
          @click="closeModal"
        >
          Fechar
        </button>
        <button
          class="btn-save"
          @click="save"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

export default {
  components: {
    "vue-cal": VueCal
  },
  props: {
    card: {
      type: Object,
      required: true,
      default: () => ({})
    },
    professionals: {
      type: Array,
      default: () => []
    }
  },
  emits: ["close", "save"],
  data() {
    return {
      editedDescription: "",
      selectedProfessional: null,
      selectedDueDate: null,
      professionalsDropdownVisible: false,
      descriptionMaxLength: 3000
    };
  },
  watch: {
    editedDescription() {
      this.autoGrow();
    }
  },
  created() {
    this.editedDescription = this.card?.description || "";
    this.selectedProfessional = this.card?.assignedProfessional?.Id
      ? { ...this.card.assignedProfessional }
      : null;
    this.selectedDueDate = this.card?.dueDate || null;
  },
  mounted() {
    this.autoGrow();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    closeDropdowns() {
      this.professionalsDropdownVisible = false;
    },
    toggleProfessionalsDropdown() {
      this.professionalsDropdownVisible = !this.professionalsDropdownVisible;
      if (this.professionalsDropdownVisible) {
        this.$nextTick(() => {
          const content = this.$refs.content;
          if (!content) return;
          content.scrollTo({
            top: content.scrollHeight,
            behavior: "smooth"
          });
        });
      }
    },
    selectProfessional(professional) {
      this.selectedProfessional = professional;
      this.professionalsDropdownVisible = false;
    },
    selectDate(date) {
      this.selectedDueDate = date.format("YYYY-MM-DD");
    },
    save() {
      this.$emit("save", {
        description: this.editedDescription,
        assignedProfessional: this.selectedProfessional,
        dueDate: this.selectedDueDate
      });
      this.$emit("close");
    },
    autoGrow() {
      this.$nextTick(() => {
        const el = this.$refs.descriptionTextarea;
        if (!el) return;
        el.style.height = "auto";
        const styles = window.getComputedStyle(el);
        const borderHeight =
          (parseFloat(styles.borderTopWidth) || 0) +
          (parseFloat(styles.borderBottomWidth) || 0);
        el.style.height = `${el.scrollHeight + borderHeight}px`;
      });
    }
  }
};
</script>

<style scoped>
@import "~@assets/css/views/lilaCalendar.css";

.actionDetails {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.actionDetails-content {
  width: 640px;
  max-width: 92%;
  max-height: 90%;
  overflow-y: auto;
  padding: 18px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
}

.actionDetails-content .action-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c2c2c;
  margin: 0 0 24px;
}

.actionDetails-content .field-section {
  margin-bottom: 14px;
}

.actionDetails-content .field-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #333;
}

.actionDetails-content .field-icon {
  flex-shrink: 0;
}

.actionDetails-content .field-title {
  font-size: 15px;
  font-weight: 600;
}

.actionDetails-content .selected-due-date {
  font-size: 14px;
  font-weight: 600;
  color: #6a1b9a;
  margin: 0 0 8px;
}

.actionDetails-content .description-textarea {
  width: 100%;
  min-height: 56px;
  padding: 10px 12px;
  border: 1px solid #d9c7e2;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.actionDetails-content .description-textarea:focus {
  outline: none;
  border-color: #6a1b9a;
  box-shadow: 0 0 0 3px rgba(106, 27, 154, 0.12);
}

.actionDetails-content .description-counter {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 4px;
}

.actionDetails-content .professional-assigned-box {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid #d9c7e2;
  border-radius: 8px;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.actionDetails-content .professional-assigned-box:hover {
  border-color: #6a1b9a;
}

.actionDetails-content .professional-assigned-box p {
  flex: 1;
  font-size: 14px;
  padding-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actionDetails-content .chevron-icon {
  flex-shrink: 0;
  color: #6a1b9a;
}

.actionDetails-content .professionals-assigned-dropdown-list {
  padding: 0;
  margin: 6px 0 0;
  list-style-type: none;
  border: 1px solid #ececec;
  border-radius: 8px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  max-height: 200px;
  overflow-y: auto;
  box-sizing: border-box;
}

.actionDetails-content .dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #4a4a4a;
}

.actionDetails-content .dropdown-item:hover {
  background-color: #f3ecf7;
  color: #6a1b9a;
}

.actionDetails-content .footer-buttons {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 30px;
  padding-top: 12px;
  border-top: 1px solid #ececec;
}

.actionDetails-content .btn-save {
  background-color: #6a1b9a;
  color: white;
  border: none;
  padding: 8px 22px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.15s;
}

.actionDetails-content .btn-save:hover {
  background-color: #4a148c;
}

.actionDetails-content .btn-cancel {
  background-color: transparent;
  color: #555;
  border: 1px solid #ccc;
  padding: 8px 22px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.15s;
}

.actionDetails-content .btn-cancel:hover {
  background-color: #f0f0f0;
}
</style>
